import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "CerExternalStack";

export const classes = {
  root: `${PREFIX}-root`,
  doneChip: `${PREFIX}-doneChip`,
};

export const CerExternalStack = styled(Stack)(({ theme }) => ({
  [`&.${classes.root}`]: {
    alignItems: "center",
    color: theme.palette.black.dark,
    [`& .MuiChip-label`]: {
      fontWeight: 600,
      fontSize: 12,
    },
    [`& .${classes.doneChip}`]: {
      color: theme.palette.gray.dark,
      border: `1px solid ${theme.palette.gray.dark}`,
    },
  },
}));
